module.exports = __webpack_public_path__ + "img/servired.200c8f20.png";